import type { IconComponent } from "@overmap-ai/blocks"
import {
	AlignCenter,
	AlignJustify,
	AlignLeft,
	AlignRight,
	Baseline,
	Bold,
	Code,
	Code2,
	Heading1,
	Heading2,
	Heading3,
	Heading4,
	Heading5,
	Highlighter,
	Italic,
	List,
	ListChecks,
	ListChevronsDownUp,
	ListOrdered,
	Redo,
	RemoveFormatting,
	SeparatorHorizontal,
	Strikethrough,
	Subscript,
	Superscript,
	TextQuote,
	Underline,
	Undo,
} from "lucide-react"

import { HeadingLevel, TextAlign } from "../enums"

export const headingDataMapping: Record<HeadingLevel, { label: string; icon: IconComponent }> = {
	[HeadingLevel.H1]: {
		label: "Heading 1",
		icon: Heading1,
	},
	[HeadingLevel.H2]: {
		label: "Heading 2",
		icon: Heading2,
	},
	[HeadingLevel.H3]: {
		label: "Heading 3",
		icon: Heading3,
	},
	[HeadingLevel.H4]: {
		label: "Heading 4",
		icon: Heading4,
	},
	[HeadingLevel.H5]: {
		label: "Heading 5",
		icon: Heading5,
	},
}

export const textAlignDataMapping: Record<TextAlign, { label: string; icon: IconComponent }> = {
	[TextAlign.CENTER]: { icon: AlignCenter, label: "Center" },
	[TextAlign.JUSTIFY]: { icon: AlignJustify, label: "Justify" },
	[TextAlign.LEFT]: { icon: AlignLeft, label: "Left" },
	[TextAlign.RIGHT]: { icon: AlignRight, label: "Right" },
}

export const tipTapIconMapping = {
	blockqoute: TextQuote,
	bold: Bold,
	bulletList: List,
	codeBlock: Code2,
	code: Code,
	horizontalRule: SeparatorHorizontal,
	italic: Italic,
	orderedList: ListOrdered,
	redo: Redo,
	undo: Undo,
	lineHeight: ListChevronsDownUp,
	strike: Strikethrough,
	subscript: Subscript,
	superscript: Superscript,
	taskList: ListChecks,
	textColor: Baseline,
	textHighlight: Highlighter,
	underline: Underline,
	unsetMarks: RemoveFormatting,
} satisfies Record<string, IconComponent>
